import React, { useContext } from 'react';
import { DropdownItem } from "reactstrap";
import { Link } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import { UserContext } from '../../context/User';

function MySolutionsNavLink() {
    const isAuthenticated = useIsAuthenticated();
    const { isHomeowner, isContractor } = useContext(UserContext);

    return (
        <>
            {
                isAuthenticated && isHomeowner() &&
                <DropdownItem tag={Link} to="/solution">My Projects</DropdownItem>
            }
            {
                isAuthenticated && isContractor() &&
                <DropdownItem tag={Link} to="/my-work">My Projects</DropdownItem>
            }
        </>
    );
}

export default MySolutionsNavLink;